module.exports = __webpack_public_path__ + "img/title.3c5bca87.png";